import TransactionVolumeDashlet from './TransactionVolumeDashlet';

export default TransactionVolumeDashlet;
